<template>
  <main class="content-container-manual">
    <div
      v-if="isDebug"
      class="error-debug"
    >
      <pre>{{ error }}</pre>
    </div>

    <div class="error">
      <img
        v-if="isMainPage"
        src="@/assets/logo-maco-outline.svg?url"
        class="img-rwd error__background-image"
        :width="350"
        :height="420"
        alt="Macopedia Logo"
      />

      <div
        v-if="error.statusCode === 404"
        class="error__content"
      >
        <LogoSmall class="error__logo" />

        <h3 class="error__header">
          {{ translation.header }}
        </h3>

        <p
          class="error__text"
          v-html="replaceLinkText(translation.text, translation.linkArray)"
        />

        <h1 class="error__status-code">
          404
        </h1>
      </div>

      <template v-else>
        <h1 class="error__status-code">
          {{ translation.error }} {{ error.statusCode }}
        </h1>
      </template>
    </div>
  </main>
</template>

<script setup lang="ts">
import type { BaseErrorPageProps } from '~ui/types'

defineProps<BaseErrorPageProps>()

const replaceLinkText = (
  string: string,
  linkArray: Array<{ label: string, href: string }>
) => {
  let index = 0

  return string.replace(/\{{.+?\}}/g, () => {
    const item = linkArray[index++]
    if (!item) return ''

    const { href, label } = item
    return `<a href="${href}">${label}</a>`
  })
}
</script>

<style lang="scss" scoped>
.content-container-manual {
  display: flex;
  align-items: center;
  justify-content: center;
}

.error {
  width: 100%;
  position: relative;
  display: grid;
  place-items: center;
  gap: rem(16px);
  text-align: center;
  isolation: isolate;
  min-height: 40vh;
  min-height: 40svh;
  height: 100%;
  padding: 80px 0;

  &__background-image {
    position: absolute;
    z-index: z-index(below);
    width: 60%;
    height: 60%;
  }

  &__content {
    display: grid;
    place-items: center;
    gap: rem(16px);
  }

  &__logo {
    margin-bottom: rem(16px);
  }

  &__header {
    font-size: rem(22px);
    font-weight: 600;
  }

  &__text {
    font-size: rem(16px);

    & a {
      font-weight: 600;
      text-decoration: underline;
    }
  }

  &__status-code {
    color: color(primary);
    font-size: rem(60px);
    margin: 0;
    font-weight: 600;

    @include media-query(md) {
      font-size: rem(120px);
    }
  }
}

.error-debug pre {
  overflow: auto;
  border: 1px solid color(primary);
  padding: em($container-padding);
}
</style>
